import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom"
import Swal from "sweetalert2";
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Grid from '@mui/joy/Grid';
import Loading from "../../components/loading";
import ModalSearchPorfolio from "./modals/modal-search-porfolio";
// SERVICES
import PortfolioManagerService from "../../services/portfolioManagerService";

function PortfolioManagers() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const initialized = useRef(false)
    const [listPorfolioManagers, setListPorfolioManagers] = useState([]);
    const [listPorfolioManagersMeta, setListPorfolioManagersMeta] = useState([]);
    const [listPorfolioManagersLinks, setListPorfolioManagersLinks] = useState([]);
    const [more, setMore] = useState(false)
    const [modalSearchOpen, setModalSearchOpen] = useState(false);
    const [searchModel, setSearchModel] = useState({
        name: '',
    })


    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true
            doSearch()
        }
    }, [false]);

    const doSearch = async () => {
            setLoading(true)
            PortfolioManagerService.getPortfolioManagers()
            .then((response) => {
                setListPorfolioManagers(response.data)
                setListPorfolioManagersMeta(response.meta)
                setListPorfolioManagersLinks(response.links)
            })
            .catch((e) => {
                const statusCode = e.response?.status
                const error = e.response?.data.errors;
                
                if(statusCode && statusCode !== 401){
                    Swal.fire({
                        title: 'ERROR',
                        text: error[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
            })
            .finally(() => { setLoading(false) })
        
    }

    const doPagination = async () => {
        setMore(true)
        PortfolioManagerService.getPortfolioManagerSearchPagination(listPorfolioManagersLinks.next)
        .then((response) => {
            response.data.forEach( data => listPorfolioManagers.push(data) )
            setListPorfolioManagersMeta(response.meta)
            setListPorfolioManagersLinks(response.links)
        })
        .catch((e) => {
            const statusCode = e.response?.status
            const error = e.response?.data.errors;
            
            if(statusCode && statusCode !== 401){
                Swal.fire({
                    title: 'ERROR',
                    text: error[0].detail,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#f13939'
                })
            }else{
                sessionStorage.removeItem("userProfile");
                navigate('/')
                window.location.reload();
            }
        })
        .finally(() => { setMore(false) })
    }

/*     const doEdit = async (obj) => {
        if(obj !== null){
            console.log(obj)
            // setUserSelected(obj)
            // setModalEditOpen(true)
        }
    } */
    
    const doNew = async () => {
        // setModalSearchOpen(true)
    }

    const doOpenModalSearch = async () => {
        setModalSearchOpen(true)
    }

    const doDelete = async (obj) => {
        if(obj !== null){
            Swal.fire({
                title: 'Atención!',
                text: "Ud. esta seguro que quiere eliminar el comercial seleccionado ?",
                icon: "warning",
                showCancelButton: true,
                // cancelButtonColor: '#efefef',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Eliminar',
                confirmButtonColor: '#f13939',
                reverseButtons: true
              })
              .then(async (result) => {
                if (result.isConfirmed) {   
                    console.log(obj)
                }
              })
        }
    }

    if(loading){ return( <Loading></Loading> ) }

    return (
        <div className="container-fluid flex-grow-1 container-p-y">

            <div className="row">
                <div className="col">
                    <h4 className="fw-bold py-3 mb-2">
                        Comerciales 
                        {listPorfolioManagersMeta.total > 0 && <span className="fontMedium">({listPorfolioManagersMeta.total})</span> }
                    </h4>
                </div>
                <div className="col">
                    <div className="btn-group float-end" role="group" aria-label="First group">
                        {/* <button type="button" className="btn btn-outline-secondary" onClick={() => doNew()}  title="Nuevo">
                            <i className="tf-icons bx bx-plus" />
                        </button> */}
                        <button type="button" className="btn btn-outline-secondary" title="Buscar" onClick={doOpenModalSearch}>
                            <i className="tf-icons bx bx-filter" />
                        </button>
                    </div>
                </div>
            </div>

            <Grid container spacing={2} sx={{ flexGrow: 1 }} className="mt-0">
                <Grid xs={12} md={12} lg={12}>
                    <Card variant="solid" color="natural" className="card">
                        <CardContent>                            
                            <table className="table table-striped">
                                <thead>
                                    <tr className="text-nowrap">
                                        <th>Nombre</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody className="table-border-bottom-0">
                                    {listPorfolioManagers.map(portfolioManager => {
                                        return (
                                            <tr key={portfolioManager.id}>
                                                <td>{portfolioManager.name}</td>
                                                <td className="text-end">
                                                <div className="dropdown">
                                                <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                                                    <i className="bx bx-dots-vertical-rounded" />
                                                </button>
                                                <div className="dropdown-menu">
                                                    {/* <a className="dropdown-item" href="javascript:void(0);"  onClick={() => {  doEdit(portfolioManager) } }> Editar </a> */}
                                                    <a className="dropdown-item" href="javascript:void(0);"  onClick={() => {  doDelete(portfolioManager.id) } }> Eliminar </a>
                                                </div>
                                                </div>
                                            </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid xs={12} md={12} lg={12}>
                    { listPorfolioManagersLinks.next !== null && !loading ?
                        <div className="row mt-4">
                            <div className="col d-grid gap-2 d-md-flex justify-content-md-center">
                            { more ? 
                                <div className="d-flex justify-content-center">
                                    <div className="spinner-border text-info" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            : 
                                <button type="button" className="btn btn-outline-info" onClick={doPagination}>Mas Información</button>
                            }
                            </div>
                        </div>
                    :  null }
                </Grid>
            </Grid>

            {/* SEARCH */}
            <ModalSearchPorfolio 
                handleOpen={setModalSearchOpen} 
                isOpen={modalSearchOpen} 
                setSearch={setSearchModel}
                search={searchModel}
                doSearch={doSearch}
            />
        
        </div>
    )
}

export default PortfolioManagers;